/**
 * 呼称の対応表（spec/design/ui-design.md §2）。
 * ドメインの用語（`spec/requirements.md` 用語集）はコード上不変とし、
 * **UIに出す言葉だけ**をここに集約する。ドメインモデルには道場の語を持ち込まない。
 * 「レベル」「ステージ」「問題」はこのファイルを経由せず画面に出してはならない。
 */

/** ユビキタス言語 → UI表記の対応表。 */
export const LABELS = {
  level: "段",
  lesson: "稽古",
  drill: "稽古",
  levelExam: "昇段試験",
  stamp: "朱印",
  stampBook: "免状帳",
  grandStamp: "免許皆伝",
  companion: "師範代 ノーマ",
  hint: "助言",
  chapterIntro: "稽古前の話",
  chapterOutro: "稽古後の話",
  buffer: "紙面",
  editor: "墨板",
  goal: "的",
  keystroke: "打鍵",
  progress: "稽古の記録",
} as const;

/** 段位の名（一段〜七段）。`levelId` は `level-1`〜`level-7` のまま変更しない。 */
export const LEVEL_RANK_NAMES: Readonly<Record<number, string>> = {
  1: "一段",
  2: "二段",
  3: "三段",
  4: "四段",
  5: "五段",
  6: "六段",
  7: "七段",
};

/** 段位の意味（運足・筆入…）。学ぶコマンドの割り当ては変更していない。 */
export const LEVEL_KANJI_NAMES: Readonly<Record<number, string>> = {
  1: "運足",
  2: "筆入",
  3: "目付",
  4: "写し",
  5: "変化",
  6: "自在",
  7: "皆伝",
};

const LEVEL_ID_PATTERN = /^level-(\d+)$/;

/** `levelId`（`level-3` 等）から段番号（1〜7）を取り出す。形式に合わなければ`null`。 */
export function parseLevelNumber(levelId: string): number | null {
  const match = LEVEL_ID_PATTERN.exec(levelId);
  if (!match) {
    return null;
  }
  return Number(match[1]);
}

/** `levelId`から表示名（例: 「一段 運足」）を組み立てる。未知の番号なら`null`。 */
export function levelDisplayName(levelId: string): string | null {
  const number = parseLevelNumber(levelId);
  if (number === null) {
    return null;
  }
  const rank = LEVEL_RANK_NAMES[number];
  const kanji = LEVEL_KANJI_NAMES[number];
  if (rank === undefined || kanji === undefined) {
    return null;
  }
  return `${rank} ${kanji}`;
}
